import type {
  ManualProcessingParams,
  ManualProcessingResult,
  RechargeItem,
  RechargeParams,
} from './types'

import type { PagingRequest } from '#/api/type'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'
import { formatDateRange } from '#/utils'

export const rechargeApi = defineApi('operation', ({ prefix }) => {
  function getRechargeListParams(params: PagingRequest<RechargeParams>) {
    return {
      transactionId: params.condition?.transactionId,
      createdTime: formatDateRange(params.condition?.createdTime),
      userId: params.condition?.userId
        ? Number(params.condition?.userId)
        : null,
      nickname: params.condition?.nickname,
      customerId: params.condition?.customerId,
      paymentChannel: params.condition?.paymentChannel,
      status: params.condition?.status,
      type: params.condition.type,
    }
  }

  function getRechargeList(params: PagingRequest<RechargeParams>) {
    params = {
      pageIndex: params.pageIndex,
      pageSize: params.pageSize,
      condition: getRechargeListParams(params),
    }
    return requestClient
      .post(prefix('wallet/listWalletRecharge'), params)
      .then((res) => {
        return {
          items:
            res?.list?.map((item: RechargeItem) => ({
              userId: item.userId,
              transactionId: item.transactionId,
              nickname: item.nickname,
              email: item.email,
              createdTime: item.createdTime,
              paymentChannel: item.paymentChannel,
              customerId: item.customerId,
              amount: item.amount,
              orderId: item.orderId,
              status: item.status,
              paymentCurrency: item.paymentCurrency,
              receivedCurrency: item.receivedCurrency,
              receivedAmount: item.receivedAmount,
              completedAt: item.completedAt,
              attch: item.attch,
              remark: item.remark,
              netCurrency: item.netCurrency,
              netAmount: item.netAmount,
              balanceCurrency: item.balanceCurrency,
              balanceCreditedAmount: item.balanceCreditedAmount,
              exchangeRate: item.exchangeRate,
              payer: item.payer,
              createdBy: item.createdBy,
            })) || [],
          total: res?.total,
        }
      })
  }

  function manualProcessing(params: ManualProcessingParams) {
    return requestClient.post<ManualProcessingResult>(
      prefix('wallet/manualProcessing'),
      {
        amount: params.amount,
        bizNos: params.bizNos,
        deviationConfirmed: params.deviationConfirmed,
        remark: params.remark,
        screenshotUrl: params.screenshotUrl,
        type: params.type,
      },
    )
  }
  return {
    getRechargeList,
    manualProcessing,
    getRechargeListParams,
  }
})
